import * as React from 'react';
import { FieldAttributes, Field, FieldProps } from 'formik';

import {
  PasswordInput,
  PasswordInputProps,
} from '@components/form/password-input';
import { FieldMessage, FieldMessageType } from '@components/form/field';

export type FormikPasswordInputProps = Omit<
  PasswordInputProps,
  keyof FieldAttributes<any>
> &
  FieldAttributes<any> & {
    name: string;
    label?: string;
  };

export const FormikPasswordInput = React.forwardRef<
  HTMLInputElement,
  FormikPasswordInputProps
>(({ name, ...props }, inputRef) => {
  return (
    <Field name={name}>
      {({ field, meta }: FieldProps) => {
        const showError = !!meta.error && meta.touched;

        return (
          <fieldset>
            <PasswordInput
              {...props}
              ref={inputRef}
              isInvalid={showError}
              name={name}
              label={props.label}
              value={field.value}
              onChange={field.onChange}
              onBlur={field.onBlur}
            />
            {showError && (
              <FieldMessage type={FieldMessageType.ERROR}>
                {meta.error}
              </FieldMessage>
            )}
          </fieldset>
        );
      }}
    </Field>
  );
});

FormikPasswordInput.displayName = 'FormikPasswordInput';
